import { defineNuxtPlugin } from '#imports'
import { currentAppBrand } from '@b2ag/app-brands'
import { loadLocaleFor } from '@b2ag/locale/src/plugins/loadLocaleFor'
import { getLocaleForI18n } from '@b2ag/utils/src/i18n-routing'

export default defineNuxtPlugin({
  name: 'locale',
  enforce: 'pre',
  async setup(nuxtApp) {
    const path = import.meta.server ? nuxtApp.ssrContext?.url || '/' : window.location.pathname

    await loadLocaleFor(currentAppBrand, getLocaleForI18n(path))
  },
})
